<template>
  <div class="new-product">
    <router-view />
  </div>
</template>

<script>
export default {}
</script>
